

const initialCodingNav = {
  isActive: false,
  testId: null,
  history: [],
  currentIndex: 0,
};

export function codingNavReducer(state = initialCodingNav, action) {
  switch (action.type) {

    case "CODING_NAV_INIT":
      return {
        isActive: true,
        testId: action.payload.testId,
        history: [action.payload.question],
        currentIndex: 0,
      };

    case "CODING_NAV_INIT_RESUME": {
      const { testId, questionsNavigation, lastQuestion, totalQuestion, candidateTestDetailId } = action.payload;
      if (!questionsNavigation || questionsNavigation.length === 0) {
        return {
          isActive: true,
          testId,
          history: [lastQuestion],
          currentIndex: 0,
        };
      }
      // The resumed question (lastQuestion) is not necessarily the last entry in
      // questionsNavigation — a candidate can go Prev before disconnecting, in which
      // case the resume point is an earlier index while later questions were still
      // visited. Match by ID instead of assuming array position, so already-visited
      // questions ahead of the resume point are preserved as placeholders rather
      // than being overwritten/dropped.
      const buildPlaceholder = (nav) => ({
        candidateQuestionId: nav.candidateQuestionId,
        candidateTestDetailId: nav.candidateTestDetailId || candidateTestDetailId,
        questionOrder: nav.questionOrder,
        isSubmitted: nav.isSubmitted,
        submitted: nav.isSubmitted,
        currentQuestion: nav.questionOrder,
        totalQuestion,
        isPlaceholder: true,
      });

      const resumeIdx = questionsNavigation.findIndex(
        (nav) => nav.candidateQuestionId === lastQuestion?.candidateQuestionId
      );

      if (resumeIdx === -1) {
        // The resumed question isn't in questionsNavigation yet (server-side lag
        // between lastQuestionId and the nav array catching up). Append it rather
        // than overwriting an existing, different question's slot.
        const history = [
          ...questionsNavigation.map(buildPlaceholder),
          { ...lastQuestion },
        ];
        return {
          isActive: true,
          testId,
          history,
          currentIndex: history.length - 1,
        };
      }

      const history = questionsNavigation.map((nav, idx) =>
        idx === resumeIdx ? { ...lastQuestion } : buildPlaceholder(nav)
      );
      return {
        isActive: true,
        testId,
        history,
        currentIndex: resumeIdx,
      };
    }

    case "CODING_NAV_FILL_QUESTION": {
      const { index, question } = action.payload;
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === index ? { ...question, isPlaceholder: false } : q
        ),
      };
    }

    case "CODING_NAV_PERSIST_CURRENT":
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex
            ? { ...q, editorState: action.payload.editorState }
            : q
        ),
      };

    case "CODING_NAV_APPEND":
      return {
        ...state,
        history: [...state.history, action.payload],
        currentIndex: state.currentIndex + 1,
      };

    case "CODING_NAV_NEXT":
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
      };

    case "CODING_NAV_PREV":
      return {
        ...state,
        currentIndex: state.currentIndex - 1,
      };

    case "CODING_NAV_MARK_SUBMITTED":
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex ? { ...q, submitted: true } : q
        ),
      };

    case "CODING_NAV_RESET":
      return initialCodingNav;

    case "CODING_NAV_UPDATE_STARTER_CODE": {
      const starter = action.payload;

      const normalizedCode =
        typeof starter === "string"
          ? starter
          : starter?.useStub
          ? ""
          : starter?.code || "";

      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex
            ? {
                ...q,
                starterCode: starter,
                editorState: {
                  ...q.editorState,
                  code: normalizedCode,
                },
              }
            : q
        ),
      };
    }

    default:
      return state;
  }
}